import React, { useState, useEffect } from 'react';
import storage from '../../higherOrder/storage';
import Header from '../Header';
import Notification from '../Notification/Notification.container';

const MainPage = ({ isNavExtended, children }) => {
    const [className, setClassName] = useState(isNavExtended ? 'page-wrapper page-wrapper-extended' : 'page-wrapper');

    useEffect(() => {
        setClassName(isNavExtended ? 'page-wrapper page-wrapper-extended' : 'page-wrapper');
    }, [isNavExtended]);

    return (
        <div className={className} id="page-wrapper">
            <Header />
            <Notification />
            {children}
        </div>
    );
};

export default storage(MainPage, 'sidebar');